import { render, staticRenderFns } from "./BorangLaporan.vue?vue&type=template&id=4e7ce5d7&scoped=true&"
import script from "./BorangLaporan.vue?vue&type=script&lang=js&"
export * from "./BorangLaporan.vue?vue&type=script&lang=js&"
import style0 from "./BorangLaporan.vue?vue&type=style&index=0&id=4e7ce5d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7ce5d7",
  null
  
)

export default component.exports